<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-row>
      <v-col cols="12">
        <v-alert v-if="error_alert" text prominent type="error" icon="mdi-cloud-alert">{{
            error_alert
          }}</v-alert>
        <v-alert
            v-if="success_alert"
            text
            prominent
            type="success"
            icon="mdi-cloud-alert"
        >{{ success_alert }}</v-alert
        >
      </v-col>
      <v-col cols="12">
        <v-card-title>
          OT Room Setup
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <template>
            <v-text-field
                v-model="search"
                prepend-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                outlined
                dense
            ></v-text-field>
          </template>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn  color="primary" @click="method_item_dialog = true"><v-icon>mdi-plus</v-icon></v-btn>
        </v-card-title>

        <v-card>
          <v-data-table
              :headers="headers"
              :items="OtRoomData"
              class="elevation-1"
              :search="search"
              dense
              mobile-breakpoint="0"
              :loading="loadingstatus"
              loading-text="Loading... Please wait"
          >
            <template v-slot:item.status="{ item }">
              <v-chip v-if="item.status == 1" dark color="green" label outlined small
              >Active
              </v-chip>
              <v-chip v-if="item.status == 0" dark color="orange" label outlined small
              >Inactive
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top >
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                      @click="get_update(item)"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      class="ma-2"
                      color="orange"
                      label
                      outlined
                      small
                  ><v-icon> mdi-pencil </v-icon>
                  </v-chip>
                </template>
                <span>Edit</span>
              </v-tooltip>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="get_otroomdata()">Reset</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>


    <template>
      <div class="text-center">
        <v-dialog v-model="method_item_dialog" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Ot Room Setup
              <span v-if="OtRoomSetup.name">: {{ OtRoomSetup.name }}</span></v-card-title
            >
            <template>
              <v-form>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                          v-model="OtRoomSetup.name"
                          outlined
                          dense
                          label="Name"
                          required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" >
                      <v-select
                          v-model="OtRoomSetup.status"
                          :items="status"
                          item-value="key"
                          item-text="value"
                          label="Item Status"
                          outlined
                          dense
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </template>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="method_item_dialog = false"> Cancel </v-btn>
              <v-btn text color="warning" @click="OtRoomSetup = {}"> Reset </v-btn>
              <v-btn color="primary" text @click="OtRoomSubmit()"> Submit </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>

  </div>
</template>

<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";

export default {
  data() {
    return {
      search: "",
      auto_search: "",
      dialog: false,
      method_item_dialog: false,
      error_alert: null,
      success_alert: null,
      loadingstatus: true,
      OtRoomData: [],
      status: [
        { key: 1, value: "Active" },
        { key: 0, value: "Inactive" },
      ],
      headers: [
        { text: "OT Room Name", value: "name" },
        { text: "Create Date", value: "created_at" },
        { text: "Status", value: "status" },
        { text: "Action", value: "actions", sortable: false },
      ],
      desserts: [],
      autoheaders: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id",
        },

        { text: "Action", value: "actions", sortable: false },
      ],
      autodesserts: [],
      formData: {
        name: null,
        status: null,
      },

      OtRoomSetup: {
        id: null,
        name: null,
        status: null,
      },

      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Administrative",
          disabled: true,
          href: "patients",
        },
        {
          text: "Ot Room",
          disabled: true,
          href: "patients",
        },
      ],

    };
  },
  // Fetches posts when the component is created.
  created() {
    let storedGroups = localStorage.getItem("userGroups") || "";
    let userGroups = storedGroups
        .split(",")
        .map(g => Number(g.trim()))
        .filter(g => !isNaN(g));

    let permittedGroups = [1, 8]; // Admin=1, Manager=8
    let hasAccess = userGroups.some(group => permittedGroups.includes(group));

    if (hasAccess) {
      console.log("Access Granted",hasAccess);
    } else {
      this.loadingstatus = false;
      this.error_alert = "Invalid Request";
      return false;
    }
    this.get_otroomdata();
  },
  methods: {
    get_otroomdata() {
      atshq
          .get("administrative/ot-room-setup")
          .then((response) => {
            this.OtRoomData = response.data.OtRoom;
            this.loadingstatus = false;
          })
          .catch((e) => {
            this.error_alert.push(e);
          });
    },

    get_update(items) {
      this.method_item_dialog = true;
      this.OtRoomSetup = items;
    },

    OtRoomSubmit() {
      if (confirm("are you sure?"))
        if (this.OtRoomSetup.id) {
          atshq
              .put("administrative/ot-room-setup/" + this.OtRoomSetup.id, {
                data: this.OtRoomSetup,
                user_id: localStorage.getItem("userId"),
              })
              .then((res) => {
                if (res.status == 200) {
                  this.$noty.success("Successfuly Updated!");
                  this.success_alert = res.data.messages;
                  this.get_otroomdata();
                  this.method_item_dialog = false;
                }
              })
              .catch((e) => {
                this.$noty.error("Oops, something went wrong!");
                this.errors.push(e);
              })
              .finally(() => {
                //Perform action in always
              });
        } else {
          atshq
              .post("administrative/ot-room-setup", {
                formdata: this.OtRoomSetup,
                user_id: localStorage.getItem("userId"),
              })
              .then((res) => {
                if (res.status == 200) {
                  this.$noty.success("Successfuly saved!");
                  this.success_alert = res.data.messages;
                  this.get_otroomdata();
                  this.method_item_dialog = false;
                }
              })
              .catch((e) => {
                this.$noty.error("Oops, something went wrong!");
                this.errors.push(e);
              })
              .finally(() => {
                //Perform action in always
              });
        }
    },
  },
};
</script>
